import React, { useEffect, useState } from 'react'
import { InputNumber } from 'antd'

const DecimalInput = ({ value: propValue, onChange, style, disabled = false }) => {
  const [value, setValue] = useState(propValue)
  const [error, setError] = useState(false)

  useEffect(() => {
    setValue(propValue)
  }, [propValue])

  const handleOnChange = (value) => {
    const isValid = !`${value}`.includes(',')
    setValue(isValid ? value : null)
    setError(!isValid)
    if (onChange && isValid) {
      onChange(value)
    }
  }

  return (
    <InputNumber
      style={style}
      value={value}
      disabled={disabled}
      onChange={handleOnChange}
      status={error ? 'error' : ''}
    />
  )
}

export default DecimalInput
